import styled from 'styled-components/macro';
import { ImageStyledWrapper } from '@yme/atoms/image';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel2 } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
import { AspectRatio } from '@yme/utils/constants';
export const ImageWrapperStyled = styled(FlexWrapper) `
  position: relative;
  width: 100%;
  aspect-ratio: ${AspectRatio.Square};

  ${ImageStyledWrapper} {
    display: flex;
    align-items: center;
  }
`;
export const ContainerIconsStyled = styled.div `
  position: absolute;
  top: ${INDENT.xxxs};
  display: flex;
  align-items: center;
  gap: ${INDENT.xxs};
  z-index: ${Z_INDEX.level1};

  ${({ isRightToLeft }) => (isRightToLeft ? `left: ${INDENT.xxxs}` : `right: ${INDENT.xxxs}`)};

  ${ADAPTIVE.minWidth.tablet} {
    ${({ isRightToLeft }) => (isRightToLeft ? `left: ${INDENT.xs}` : `right: ${INDENT.xs}`)};
  }
`;
export const TitleStyled = styled(RegularTextLevel2) `
  margin-top: ${INDENT.xs};
`;
